// extracted by mini-css-extract-plugin
export default {"clickable":"copyCell_clickable__91W6S","copyCell":"copyCell_copyCell__vvySf","copyCell__button":"copyCell_copyCell__button__rnBer"};